module.exports = __webpack_public_path__ + "img/pEasyW.3b78b305.svg";